var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a, _b;
import React, { forwardRef, useMemo, useRef, useState, } from 'react';
// @ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { FaChevronDown, FaChevronUp, FaMinus, FaPlus } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { TagType, WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCreateWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import FSButton from '@components/FSButton';
import Tags from '@shared/tags/Tags';
import Input from '@shared/input/Input';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import TextInput from '@shared/input/TextInput';
import { useHover } from '@hooks/useHover';
import { CheckBox } from '@shared/input/CheckBox';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import ColorPickerInput from '@shared/input/ColorPicker';
import SelectInput from '@shared/input/SelectInput';
import { chartTypeOptions, colorblindPalette, distinctPalette, stackedOptions } from '@shared/chart/util';
import { Chart, Color, ColorPalette, FormatType, NumFmt } from '@util/enums';
import { ModalBody } from '@styled/Modal';
import { ChartLineButton } from '@styled/Widget';
import { FlexRowRight } from '@styled/FlexWrappers';
import { GridLine, TemplatedGrid } from '@styled/Grid';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
function ChartEditor(props) {
    var formRef = useRef(null);
    return (React.createElement(Modal, { width: 900 },
        React.createElement(ChartEditorForm, __assign({}, props, { ref: formRef }))));
}
var DEFAULT_FORMAT_TYPE_OPTIONS_MAP = (_a = {},
    _a[Chart.PIE] = [
        {
            label: 'Percentage',
            value: FormatType.PERCENTAGE,
        },
        { label: 'Value', value: FormatType.VALUE },
        { label: 'Custom', value: FormatType.CUSTOM },
    ],
    _a[Chart.COMBINED] = [
        { label: 'Value', value: FormatType.VALUE },
        { label: 'Custom', value: FormatType.CUSTOM },
    ],
    _a);
var DEFAULT_FORMAT_OPTIONS_MAP = (_b = {},
    _b[FormatType.VALUE] = [
        { label: 'Whole', value: NumFmt.WHOLE },
        { label: 'Two decimals', value: NumFmt.TWO_DECIMALS },
        { label: 'Thousands', value: NumFmt.THOUSANDS },
        { label: 'Millions', value: NumFmt.MILLIONS },
        { label: 'Billions', value: NumFmt.BILLIONS },
        {
            label: 'Thousands, Millions, Billions',
            value: NumFmt.K_M_B,
        },
    ],
    _b[FormatType.PERCENTAGE] = [
        { label: 'Whole', value: NumFmt.PERCENT },
        { label: 'Two decimals', value: NumFmt.PERCENT_TWO_DECIMALS },
    ],
    _b);
var MIN_X_AXIS_COLUMNS = 1;
var MAX_X_AXIS_COLUMNS = 3;
var CHART_TYPE_OPTIONS = [
    {
        value: Chart.COMBINED,
        label: 'Combined (Area, Bar, Line)',
    },
    {
        value: Chart.PIE,
        label: 'Pie',
    },
];
var DEFAULT_LINE = {
    chartType: 0,
    dataType: 0,
    numbersFormat: 1,
    title: 'New Line',
    tags: [],
    stacked: 0,
};
var ChartEditorForm = forwardRef(function (props, ref) {
    var e_1, _a;
    var _this = this;
    var _b, _c, _d;
    var L = useLanguage().L;
    var createWidget = useCreateWidget();
    var updateWidget = useUpdateWidget();
    var userColorPalette = useBranch({
        userColorPalette: ['state', 'longterm_settings', 'user', 'color_palette'],
    }).userColorPalette;
    var tagData = useTagContext().tagData;
    var colors = userColorPalette === ColorPalette.COLORBLIND ? colorblindPalette : distinctPalette;
    var colorsIdxRef = useRef(0);
    var _e = __read(useState(props.widget
        ? props.widget
        : {
            title: '',
            type: WidgetType.CHART,
            config: JSON.stringify(parseWidgetConfig(null, WidgetType.CHART)),
            GridId: props.gridId,
        }), 2), widgetState = _e[0], setWidgetState = _e[1];
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widgetState.config, WidgetType.CHART); }, [widgetState.config]);
    var _f = __read(useState({}), 2), invalid = _f[0], setInvalid = _f[1];
    var validate = function (payload, payloadConfig) {
        var invalid = {};
        if (payloadConfig.lines.length <= 0) {
            invalid.lines = L('You must add at least one chart line.');
        }
        if ((payloadConfig.xAxisTagIds.length <= 0 || payloadConfig.xAxisTagIds.every(function (d) { return !d.length; })) &&
            !(payloadConfig.chartType === Chart.PIE)) {
            invalid.xAxisTagIds = L('You must add at least one x axis tag');
        }
        return invalid;
    };
    var done = function () { return __awaiter(_this, void 0, void 0, function () {
        var widgetCopy, widgetCopyConfig, _invalid, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    widgetCopy = __assign({}, widgetState);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.CHART);
                    _invalid = validate(widgetCopy, widgetCopyConfig);
                    if (!(Object.keys(_invalid).length > 0)) return [3 /*break*/, 1];
                    setInvalid(_invalid);
                    return [3 /*break*/, 6];
                case 1:
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    if (!('id' in widgetCopy)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createWidget.mutateAsync(widgetCopy)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    _a;
                    Manager.closeModal();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleTitleChange = function (newTitle) {
        var editedWidget = __assign({}, widgetState);
        editedWidget.title = newTitle;
        setWidgetState(editedWidget);
    };
    var setTagSlicer = function (val) {
        var editedWidget = __assign({}, widgetState);
        var editedWidgetConfig = parseWidgetConfig(editedWidget.config, WidgetType.CHART);
        editedWidgetConfig.useTagSlicers = val;
        editedWidget.config = JSON.stringify(editedWidgetConfig);
        setWidgetState(editedWidget);
    };
    function multiSelectRemoveHandler(e) {
        var configCopy = __assign(__assign({}, widgetConfig), { xAxisTagIds: __spreadArray([], __read(widgetConfig.xAxisTagIds), false) });
        var filterIds = e.selectedValues.map(Number);
        configCopy.xAxisTagIds[e.columnIdx] = configCopy.xAxisTagIds[e.columnIdx].filter(function (id) { return !filterIds.includes(id); });
        setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
    }
    function multiSelectAddHandler(e) {
        var _a;
        var configCopy = __assign(__assign({}, widgetConfig), { xAxisTagIds: __spreadArray([], __read(widgetConfig.xAxisTagIds), false) });
        var newId = Number(e.value);
        var children = tagData.tagsByParentId[newId];
        var customAxisCopy = __spreadArray([], __read(((_a = configCopy.xAxisTagIds[e.columnIdx]) !== null && _a !== void 0 ? _a : [])), false);
        var uniqueIds = new Set((children === null || children === void 0 ? void 0 : children.length) ? __spreadArray(__spreadArray([], __read(customAxisCopy), false), __read(children.map(function (c) { return c.id; })), false) : __spreadArray(__spreadArray([], __read(customAxisCopy), false), [newId], false));
        configCopy.xAxisTagIds[e.columnIdx] = Array.from(uniqueIds);
        setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
    }
    function columnNumberChangeHandler(e) {
        var configCopy = __assign(__assign({}, widgetConfig), { xAxisTagIds: __spreadArray([], __read(widgetConfig.xAxisTagIds), false) });
        configCopy.xAxisTagIds.length = e.target.value;
        if (configCopy.xAxisTagIds[configCopy.xAxisTagIds.length - 1] === undefined) {
            configCopy.xAxisTagIds[configCopy.xAxisTagIds.length - 1] = [];
        }
        setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
    }
    function addDefaultLine() {
        colorsIdxRef.current = ++colorsIdxRef.current < colors.length ? colorsIdxRef.current : 0;
        var defaultLine = __assign(__assign({}, DEFAULT_LINE), { color: colors[colorsIdxRef.current] });
        var configCopy = __assign({}, widgetConfig);
        configCopy.lines = __spreadArray([defaultLine], __read(configCopy.lines), false);
        setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
    }
    function handleNumFmtChange(e) {
        var configCopy = __assign({}, widgetConfig);
        configCopy.labels = __assign(__assign({}, configCopy.labels), { type: configCopy.labels.type, numFmt: e.target.value });
        setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
    }
    var title = props.widget ? "".concat(L('Editing Chart'), " \"").concat(props.widget.title, "\"") : L('Create New Chart');
    var isPie = widgetConfig.chartType === Chart.PIE;
    var customAxisOptions = [[]];
    var xAxisTagIds = [];
    try {
        for (var _g = __values(widgetConfig.xAxisTagIds), _h = _g.next(); !_h.done; _h = _g.next()) {
            var column = _h.value;
            xAxisTagIds.push(column.filter(function (id) { return !!tagData.tagById[id]; }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (xAxisTagIds.length === 0) {
        xAxisTagIds.push([]);
    }
    var length = xAxisTagIds.length;
    for (var i = 0; i < length; i++) {
        var column = xAxisTagIds[i];
        var columnOptions = column === null || column === void 0 ? void 0 : column.map(function (id) {
            var tag = tagData.tagById[id];
            return { label: tag === null || tag === void 0 ? void 0 : tag.name, value: tag === null || tag === void 0 ? void 0 : tag.id };
        });
        customAxisOptions[i] = columnOptions !== null && columnOptions !== void 0 ? columnOptions : [];
    }
    var lines = widgetConfig.lines.map(function (line, idx) {
        return (React.createElement(ChartLineItem, { isPie: isPie, key: "chart-line-".concat(idx), line: line, lineIndex: idx, numberOfLines: widgetConfig.lines.length, tagById: tagData.tagById, changeHandler: function (e) {
                var configCopy = __assign({}, widgetConfig);
                var lineCopy = __assign({}, line);
                lineCopy[e.target.name] = e.target.value;
                configCopy.lines = __spreadArray([], __read(configCopy.lines), false);
                configCopy.lines[idx] = lineCopy;
                setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
            }, changeIndexHandler: function (moveUp) {
                var configCopy = __assign({}, widgetConfig);
                var linesCopy = __spreadArray([], __read(configCopy.lines), false);
                if (moveUp) {
                    // reduce index by 1
                    var before = linesCopy.slice(0, idx - 1);
                    var after = linesCopy.slice(idx + 1);
                    var lineBefore = linesCopy[idx - 1];
                    var line_1 = linesCopy[idx];
                    configCopy.lines = __spreadArray(__spreadArray(__spreadArray([], __read(before), false), [line_1, lineBefore], false), __read(after), false).filter(function (l) { return l !== undefined; });
                }
                else {
                    // increase index by 1
                    var before = linesCopy.slice(0, idx);
                    var after = linesCopy.slice(idx + 2);
                    var lineAfter = linesCopy[idx + 1];
                    var line_2 = linesCopy[idx];
                    configCopy.lines = __spreadArray(__spreadArray(__spreadArray([], __read(before), false), [lineAfter, line_2], false), __read(after), false).filter(function (l) { return l !== undefined; });
                }
                setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
            }, deleteHandler: function () {
                var configCopy = __assign({}, widgetConfig);
                configCopy.lines = configCopy.lines.filter(function (l, targetIdx) { return targetIdx !== idx; });
                setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
            } }));
    });
    var horizontalCheck = !isPie ? (React.createElement(FormField, null,
        React.createElement(CheckBox, { action: function () {
                var configCopy = __assign(__assign({}, widgetConfig), { chartHorizontal: !widgetConfig.chartHorizontal });
                setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
            }, checked: widgetConfig.chartHorizontal, label: L('Horizontal Chart') }))) : null;
    var hideAxisCheck = !isPie ? (React.createElement(FormField, null,
        React.createElement(CheckBox, { action: function () {
                var configCopy = __assign(__assign({}, widgetConfig), { hideAxis: !widgetConfig.hideAxis });
                setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
            }, checked: widgetConfig.hideAxis, label: L('Hide Axis') }))) : null;
    var labelTypeOptions = DEFAULT_FORMAT_TYPE_OPTIONS_MAP[widgetConfig.chartType];
    var labelNumFmtOptions = (_b = DEFAULT_FORMAT_OPTIONS_MAP[widgetConfig.labels.type]) !== null && _b !== void 0 ? _b : [];
    var labelsType = widgetConfig.showLabels ? (React.createElement(SelectInput, { label: "Label Format Type", name: "labelsType", disabled: labelTypeOptions.length < 1, value: (_c = widgetConfig.labels) === null || _c === void 0 ? void 0 : _c.type, options: labelTypeOptions, bottomMargin: true, onChange: function (e) {
            var configCopy = __assign({}, widgetConfig);
            configCopy.labels = __assign(__assign({}, configCopy.labels), { numFmt: e.target.value === configCopy.labels.type ? configCopy.labels.numFmt : NumFmt.WHOLE, type: e.target.value });
            setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
        } })) : null;
    var labelsNumFmt = widgetConfig.showLabels ? (widgetConfig.labels.type !== FormatType.CUSTOM ? (React.createElement(SelectInput, { label: L('Label Format'), name: "labelsNumFmt", value: widgetConfig.labels.numFmt, options: labelNumFmtOptions, onChange: handleNumFmtChange, bottomMargin: true })) : (React.createElement(TextInput, { label: L('Label Format'), value: widgetConfig.labels.numFmt, name: "labelsNumFmt", onChange: handleNumFmtChange, bottomMargin: true }))) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(TextInput, { label: L('Title'), value: widgetState.title, name: "title", onChange: function (e) { return handleTitleChange(e.target.value); }, bottomMargin: true }),
                React.createElement(SelectInput, { bottomMargin: true, name: "chartType", value: widgetConfig.chartType, options: CHART_TYPE_OPTIONS, onChange: function (e) {
                        var configCopy = __assign({}, widgetConfig);
                        configCopy.chartType = e.target.value;
                        setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
                    } }),
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: function () {
                            var configCopy = __assign(__assign({}, widgetConfig), { showLabels: !widgetConfig.showLabels });
                            setWidgetState(__assign(__assign({}, widgetState), { config: JSON.stringify(configCopy) }));
                        }, checked: widgetConfig.showLabels, label: L('Show Value Labels') })),
                labelsType,
                labelsNumFmt,
                horizontalCheck,
                hideAxisCheck,
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: function () { return setTagSlicer(!widgetConfig.useTagSlicers); }, checked: widgetConfig.useTagSlicers, label: L('Use Data From Dimension Slicers') })),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormField, null,
                        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                            React.createElement(FormFieldLabel, null, L('X Axis Dimension Builder')),
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                                React.createElement(FormFieldLabel, { style: { marginRight: '10px' } }, L('Add/Remove x Axis Column')),
                                React.createElement(ButtonOnlySpinner, { disabled: isPie, value: length, min: MIN_X_AXIS_COLUMNS, max: MAX_X_AXIS_COLUMNS, onChange: columnNumberChangeHandler })))),
                    React.createElement(MultiColumnMultiSelect, { disabled: isPie, columnOptions: customAxisOptions, removeHandler: multiSelectRemoveHandler, addHandler: multiSelectAddHandler }),
                    React.createElement(FormFieldErrorHelp, null, (_d = invalid.xAxisTagIds) !== null && _d !== void 0 ? _d : '')),
                React.createElement(FormField, null,
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                        React.createElement(FormFieldLabel, null, L('Y axis items')),
                        React.createElement(FlexRowRight, null,
                            React.createElement(FSButton, { "$type": "tertiary", type: "button", title: L('Add chart line'), style: { right: 0, marginBottom: 10 }, onClick: addDefaultLine }))),
                    React.createElement("div", { style: { maxHeight: 120, overflowY: 'auto' } }, lines),
                    invalid.lines && React.createElement(FormFieldErrorHelp, { "$center": true }, invalid.lines)))),
        React.createElement(ModalFooter, { done: done })));
});
function MultiColumnMultiSelect(props) {
    var e_2, _a;
    var disabled = props.disabled, columnOptions = props.columnOptions, addHandler = props.addHandler, removeHandler = props.removeHandler;
    var _b = __read(useState([]), 2), selections = _b[0], setSelections = _b[1];
    function internalChangeHandler(e) {
        var selectionsCopy = selections.map(function (s) { return __spreadArray([], __read(s), false); });
        var columnIdx = Number(e.target.name);
        selectionsCopy[columnIdx] = [];
        for (var i = 0; i < e.target.selectedOptions.length; i++) {
            var option = e.target.selectedOptions[i];
            selectionsCopy[columnIdx].push(option.value);
        }
        setSelections(selectionsCopy);
    }
    var selectedItems = [];
    try {
        for (var _c = __values(columnOptions !== null && columnOptions !== void 0 ? columnOptions : []), _d = _c.next(); !_d.done; _d = _c.next()) {
            var co = _d.value;
            selectedItems.push.apply(selectedItems, __spreadArray([], __read(co.map(function (o) { return ({
                id: o.value,
                inherited: false,
                originalClusterId: 0,
                originalClusterTitle: '',
            }); })), false));
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var selectColumns = columnOptions === null || columnOptions === void 0 ? void 0 : columnOptions.map(function (co, idx) {
        var selection = selections === null || selections === void 0 ? void 0 : selections[idx];
        function removeOnKeyDownAdapterHandler(e) {
            if (e.key === 'Backspace' || e.key === 'Delete') {
                var selectionsCopy = selections.map(function (s) { return __spreadArray([], __read(s), false); });
                selectionsCopy[idx] = selectionsCopy[idx].filter(function (s) { return !selection.some(function (v) { return v === s; }); });
                setSelections(selectionsCopy);
                removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler({ columnIdx: idx, selectedValues: selection });
            }
        }
        function selectAllHandler() {
            var selectionsCopy = selections.map(function (s) { return __spreadArray([], __read(s), false); });
            selectionsCopy[idx] = co.map(function (o) { return o.value.toString(); });
            setSelections(selectionsCopy);
        }
        function removeHandlerAdapter(e) {
            var selectionsCopy = selections.map(function (s) { return __spreadArray([], __read(s), false); });
            selectionsCopy[idx] = selectionsCopy[idx].filter(function (s) { return !e.selectedValues.some(function (v) { return v === s; }); });
            setSelections(selectionsCopy);
            removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler({ columnIdx: idx, selectedValues: e.selectedValues });
        }
        return (React.createElement(MultiSelectColumn, { name: "".concat(idx), key: "".concat(idx), options: co, values: selection, disabled: disabled, selectedItems: selectedItems, changeHandler: internalChangeHandler, removeHandler: removeHandlerAdapter, addHandler: function (e) { return addHandler === null || addHandler === void 0 ? void 0 : addHandler({ columnIdx: idx, value: e.value }); }, selectAllHandler: selectAllHandler, keyDownHandler: removeOnKeyDownAdapterHandler }));
    });
    var colTemplate = columnOptions === null || columnOptions === void 0 ? void 0 : columnOptions.map(function () { return '1fr'; }).join(' ');
    return (React.createElement(TemplatedGrid, { style: {
            marginBottom: '5px',
            marginTop: '5px',
            alignItems: 'center',
        }, "$colTemplate": colTemplate }, selectColumns));
}
function SelectOption(props) {
    var value = props.value, label = props.label;
    var _a = __read(useHover(), 2), optionRef = _a[0], isHovered = _a[1];
    return (React.createElement("option", { ref: optionRef, style: {
            height: 24,
            fontSize: 12,
            padding: '3px 9px',
            backgroundColor: isHovered ? Color.GREY_2 : '',
        }, value: value }, label));
}
function MultiSelect(props) {
    var name = props.name, _a = props.values, values = _a === void 0 ? [] : _a, _b = props.options, options = _b === void 0 ? [] : _b, _c = props.innerRef, innerRef = _c === void 0 ? null : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, changeHandler = props.changeHandler, focusHandler = props.focusHandler, blurHandler = props.blurHandler, keyDownHandler = props.keyDownHandler;
    var optionItems = options.map(function (o) { return React.createElement(SelectOption, __assign({ key: o.value }, o)); });
    return (React.createElement("select", { disabled: disabled, style: {
            borderWidth: 1,
            appearance: 'none',
            borderStyle: 'solid',
            borderColor: Color.GREY_2,
            borderRadius: 5,
            height: "10em",
            overflowY: 'auto',
            outline: 0,
            padding: '5px 0px',
        }, ref: innerRef, value: values, name: name, multiple: true, onChange: changeHandler, onFocus: focusHandler, onBlur: blurHandler, onKeyDown: keyDownHandler }, optionItems));
}
function MultiSelectColumn(props) {
    var _a;
    var name = props.name, disabled = props.disabled, selectedItems = props.selectedItems, addHandler = props.addHandler, removeHandler = props.removeHandler, selectAllHandler = props.selectAllHandler;
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', width: '100%' } },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: 4,
                marginBottom: 4,
            } },
            React.createElement(FSButton, { "$type": "tertiary", disabled: disabled, title: "Select all", style: { marginRight: 10 }, onClick: function () { return selectAllHandler === null || selectAllHandler === void 0 ? void 0 : selectAllHandler({ name: name }); } }),
            React.createElement(Tags, { disabled: disabled, select: function (id) {
                    addHandler === null || addHandler === void 0 ? void 0 : addHandler({ name: name, value: id.toString() });
                }, remove: function () { }, hideTags: true, tags: selectedItems, filterByTypes: [TagType.Table, TagType.Dimension] })),
        React.createElement(MultiSelect, __assign({}, props, { disabled: disabled })),
        React.createElement("div", { style: { alignSelf: 'flex-end', display: 'flex', alignItems: 'center', marginTop: 4, marginBottom: 4 } },
            React.createElement(FSButton, { "$type": "tertiary", "$color": "error", type: "button", title: "Remove selected", disabled: !((_a = props.values) === null || _a === void 0 ? void 0 : _a.length) || disabled, onClick: function () { var _a; return removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler({ name: name, selectedValues: (_a = props.values) !== null && _a !== void 0 ? _a : [] }); } }))));
}
function ButtonOnlySpinner(props) {
    var min = props.min, max = props.max, value = props.value, disabled = props.disabled, onChange = props.onChange;
    var snappedValue = value;
    var decrementDisabled = disabled;
    var incrementDisabled = disabled;
    if (min !== undefined && value <= min) {
        snappedValue = min;
        decrementDisabled = true;
    }
    if (max !== undefined && value >= max) {
        snappedValue = max;
        incrementDisabled = true;
    }
    function incrementAdapterHandler() {
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { value: snappedValue ? snappedValue + 1 : undefined } });
    }
    function decrementAdapterHandler() {
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { value: snappedValue ? snappedValue - 1 : undefined } });
    }
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
        } },
        React.createElement("button", { disabled: decrementDisabled, onClick: decrementAdapterHandler, style: {
                all: 'unset',
                borderWidth: 1,
                display: 'flex',
                cursor: decrementDisabled ? 'unset' : 'pointer',
                padding: '5px 7px',
                alignItems: 'center',
                borderStyle: 'solid',
                borderColor: Color.GREY_2,
                borderTopLeftRadius: 99999,
                borderBottomLeftRadius: 99999,
            } },
            React.createElement(FaMinus, { size: 11, color: decrementDisabled ? Color.GREY_2 : 'black' })),
        React.createElement("button", { disabled: incrementDisabled, onClick: incrementAdapterHandler, style: {
                all: 'unset',
                borderWidth: 1,
                display: 'flex',
                cursor: incrementDisabled ? 'unset' : 'pointer',
                padding: '5px 7px',
                alignItems: 'center',
                borderStyle: 'solid',
                borderColor: Color.GREY_2,
                borderTopRightRadius: 99999,
                borderBottomRightRadius: 99999,
            } },
            React.createElement(FaPlus, { size: 11, color: incrementDisabled ? Color.GREY_2 : 'black' }))));
}
function ChartLineItem(props) {
    var e_3, _a;
    var line = props.line, tagById = props.tagById, isPie = props.isPie, lineIndex = props.lineIndex, numberOfLines = props.numberOfLines, changeHandler = props.changeHandler, changeIndexHandler = props.changeIndexHandler, deleteHandler = props.deleteHandler;
    var chartLine = __assign({}, line);
    var colorChangeHandler = function (color) {
        changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ target: { name: 'color', value: color } });
    };
    var titleChageHandler = function (e) {
        changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ target: { name: 'title', value: e.target.value } });
    };
    var addTagHandler = function (tagId) {
        changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ target: { name: 'tags', value: __spreadArray(__spreadArray([], __read(chartLine.tags), false), [tagId], false) } });
    };
    var removeTagHandler = function (tagId) {
        changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ target: { name: 'tags', value: chartLine.tags.filter(function (t) { return t !== tagId; }) } });
    };
    var selectedTags = [];
    try {
        for (var _b = __values(chartLine.tags), _c = _b.next(); !_c.done; _c = _b.next()) {
            var tId = _c.value;
            var tag = tagById[tId];
            if (!tag) {
                continue;
            }
            selectedTags.push(tag);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var mixedCharInputs = !isPie ? (React.createElement(React.Fragment, null,
        React.createElement(SelectInput, { css: { width: '100%' }, value: chartLine.chartType, options: chartTypeOptions, onChange: function (e) {
                changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ target: { name: 'chartType', value: e.target.value } });
            } }),
        ' ',
        React.createElement(SelectInput, { css: { width: '100%' }, name: "stacked", options: stackedOptions, value: chartLine.stacked, onChange: function (e) {
                changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ target: { name: 'stacked', value: e.target.value } });
            } }))) : null;
    var firstItem = lineIndex <= 0;
    var lastItem = lineIndex >= numberOfLines - 1;
    return (React.createElement(GridLine, { "$colTemplate": "28px  ".concat(isPie ? '' : '120px 80px', " 140px auto 28px 28px 28px"), style: { justifyItems: 'center' } },
        React.createElement(ColorPickerInput, { changeHandler: colorChangeHandler, currentColor: chartLine.color }),
        React.createElement(Input, { name: "title", value: chartLine.title, onChange: titleChageHandler }),
        mixedCharInputs,
        React.createElement(Tags, { remove: removeTagHandler, select: addTagHandler, tags: selectedTags, style: { justifySelf: 'flex-start', width: '100%', paddingTop: 3 } }),
        firstItem ? (React.createElement("div", null)) : (React.createElement(ChartLineButton, { onClick: function () { return changeIndexHandler(true); } },
            React.createElement(FaChevronUp, { color: Color.BLUE }))),
        lastItem ? (React.createElement("div", null)) : (React.createElement(ChartLineButton, { onClick: function () { return changeIndexHandler(false); } },
            React.createElement(FaChevronDown, { color: Color.BLUE }))),
        React.createElement(ChartLineButton, { onClick: deleteHandler },
            React.createElement(RiDeleteBin6Line, { color: Color.RED }))));
}
export default ChartEditor;
